// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xh17","inner":"Footer_inner__2B9kE"};